import React from 'react';
import NodePersonalizado from './NodePersonalizado';

import "./style.scss"

export default function NodeEntrada({ data, id, type, ...rest }) {
    return <NodePersonalizado id={id} label={data?.nome} data={data} type={type} handles={1} {...rest} />
}